import React from "react";
import { ShopCenter } from "@/components/ShopCenter";
const Shein = () => <ShopCenter brand="shein" />;
export default Shein;
